module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8023.f86cfb89.png";